import axios from 'axios';
import message from 'antd/lib/message';

import { normalize } from 'normalizr';
import { batchActions } from 'redux-batched-actions';

import * as api from '../../api/apiko-api';
import { getResErrorMsg } from '../../utils';
import * as schemes from '../../api/schemes';
import * as tasksActions from '../actions/tasks';
import * as actions from '../actions/meeting-notes';
import * as contactsActions from '../actions/contacts';
import * as requestsActions from '../actions/requests';

const getNextPage = ({ meetingNotes: { page } }) => page + 1;

/**
 * fetchMeetingNotes :: (Boolean, Object) -> (Func, Func) -> Promise Error _
 */
export const fetchMeetingNotes = (withRateOnly = false, cancelToken) => (dispatch, getState) =>
  Promise.resolve(dispatch(actions.fetchMeetingNotesRequest()))
    .then(() => api.fetchMeetingNotes({ page: getNextPage(getState()), withRateOnly, cancelToken }))
    .then((res) => {
      const { result, entities } = normalize(
        res,
        schemes.meetingNotes,
      );
      return dispatch(batchActions([
        actions.fetchMeetingNotesSuccess({
          existsMore: result.existsMore,
          ids: result.meetingNotes,
          meetingNotes: entities.meetingNotes,
        }),
        contactsActions.fetchContactsSuccess({
          contacts: entities.contacts,
          notNewPage: true,
        }),
        requestsActions.fetchRequestsSuccess({
          requests: entities.requests,
          notNewPage: true,
        }),
        tasksActions.fetchTasksSuccess({
          tasks: entities.tasks,
          notNewPage: true,
        }),
      ]));
    })
    .catch((error) => {
      if (axios.isCancel(error)) return;

      dispatch(actions.fetchMeetingNotesFailure());
      message.error(`Failed to fetch meeting notes: ${getResErrorMsg(error)}`);
    });

/**
 * handleCreateMeetingNote :: Object -> Func -> Promise Error _
 */
export const handleCreateMeetingNote = data => dispatch =>
  Promise.resolve(dispatch(actions.createMeetingNoteRequest()))
    .then(() => api.createMeetingNote(data))
    .then((meetingNote) => {
      const { entities } = normalize(
        meetingNote,
        schemes.meetingNote,
      );

      message.success('Meeting note created');

      dispatch(batchActions([
        actions.createMeetingNoteSuccess(entities.meetingNotes[meetingNote._id]),
        requestsActions.addRequestMeetingNote({
          requestId: meetingNote.request._id,
          meetingNoteId: meetingNote._id,
        }),
        contactsActions.fetchContactsSuccess({
          contacts: entities.contacts,
          notNewPage: true,
        }),
      ]));
    })
    .catch((error) => {
      dispatch(actions.createMeetingNoteFailure());

      message.error(`Failed to create meeting note: ${getResErrorMsg(error)}`);
      return Promise.reject(error);
    });

/**
* handleUpdateMeetingNote :: (ID, Object) -> Func -> Promise Error _
*/
export const handleUpdateMeetingNote = (meetingNoteId, modifier) => dispatch =>
  Promise.resolve(dispatch(actions.updateMeetingNoteRequest()))
    .then(() => api.updateMeetingNote(meetingNoteId, modifier))
    .then(({ meetingNote }) => {
      message.success('Meeting note updated');
      dispatch(actions.updateMeetingNoteSuccess(meetingNote));
    })
    .catch((error) => {
      dispatch(actions.updateMeetingNoteFailure());
      message.error(`Failed to update meeting note: ${getResErrorMsg(error)}`);
      return Promise.reject(error);
    });

/**
 * handleMeetingNoteDelete :: (ID, Number) -> Func -> Promise Error _
 */
export const handleMeetingNoteDelete = (meetingNoteId, notesLength) => dispatch =>
  Promise.resolve(dispatch(actions.deleteMeetingNoteRequest()))
    .then(() => api.deleteMeetingNote(meetingNoteId))
    .then(({ meetingNote }) => {
      message.success('Meeting note removed');
      return dispatch(batchActions([
        dispatch(actions.deleteMeetingNoteSuccess(meetingNote)),
        requestsActions.removeRequestMeetingNote({
          requestId: meetingNote.requestId,
          meetingNoteId: meetingNote._id,
        }),
        requestsActions.setCollapseKey({ arrayLength: notesLength - 1 }),
      ]));
    })
    .catch((error) => {
      dispatch(actions.deleteMeetingNoteFailure());
      message.error(`Failed to delete meeting note: ${getResErrorMsg(error)}`);
    });



// WEBPACK FOOTER //
// ./src/redux/thunk/meeting-notes.js